import { getMixpanelInstance, initMixpanel } from './mixpanel'

type TMixpanelProperties = Record<
  string,
  string | number | boolean | null | undefined
>

const ensureInstance = () => getMixpanelInstance() ?? initMixpanel()

/**
 * 믹스패널 이벤트를 전송한다. 서버 사이드·토큰 미설정 시 no-op.
 * 개인정보(전화번호 등)는 properties 에 넣지 않는다.
 */
export const trackMixpanel = (
  eventName: string,
  properties?: TMixpanelProperties
) => {
  if (typeof window === 'undefined') return

  try {
    const instance = ensureInstance()
    if (!instance) return

    // dev 환경 콘솔 로그는 mixpanel.init({ debug }) 가 대신 출력한다.
    instance.track(eventName, properties)
  } catch (error) {
    console.error('Failed to track Mixpanel event:', error)
  }
}

const ONCE_KEY_PREFIX = 'mp_once_'

/**
 * 기기(브라우저) 단위로 1회만 전송한다. localStorage 플래그로 중복을 차단한다.
 * ⚠️ 진짜 "사람" 단위가 아니라 기기/브라우저 단위 — 시크릿모드·기기 변경 시 재전송된다.
 */
export const trackMixpanelOnce = ({
  onceKey,
  eventName,
  properties,
}: {
  onceKey: string
  eventName: string
  properties?: TMixpanelProperties
}) => {
  if (typeof window === 'undefined') return

  try {
    const storageKey = `${ONCE_KEY_PREFIX}${onceKey}`
    if (localStorage.getItem(storageKey)) return

    trackMixpanel(eventName, properties)
    localStorage.setItem(storageKey, '1')
  } catch (error) {
    console.error('Failed to track once Mixpanel event:', error)
  }
}
